export default {
  methods: {
    formatTime(time) {
      if (time <= 3600) return new Date(time * 1000).toISOString().substr(14, 5)

      return [
        parseInt(time / 60 / 60),
        parseInt((time / 60) % 60),
        parseInt(time % 60),
      ]
        .join(':')
        .replace(/\b(\d)\b/g, '0$1')
    },
  },
}
